import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../App";
import frame from "../../Assets/Images/CHOOSE-CATEGORY-Box.png";
import "../../components/CSS/Category/Category.css";
import Navigation from "../../components/Layouts/Header/Navigation";

import "./CategoryBtn";
import "./CoreCategory.css";

const CoreCategory = () => {


  const { imageCdnUrl } = useContext(serverInfo);

  const [loader, setLoader] = React.useState(false);
  const [loading, setLoading] = useState(true);
  const [categoryList, setCategoryList] = useState([]);
  const [selectCategory, setCategory] = useState([]);

  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [buffer, setBuffer] = useState(false);
  const history = useHistory();

  useEffect(() => {
    axios.get(`/api/view-category`).then((res) => {
      setBuffer(true);
      if (res.status === 200) {
        setCategoryList(res.data.category);
      }
      setLoading(false);
    });
  }, []);

  // @TODO: All Select Functionality
  const handleSelectAll = () => {
    setIsCheckAll(!isCheckAll);

    setIsCheck(categoryList.map((li) => li.id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  // @TODO: Select Unselect Functionality
  const handleClick = (e) => {
    const { id, checked } = e.target;
    const parseId = parseInt(id);
    setIsCheck([...isCheck, parseId]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== parseId));
    }
  };

  const loginSubmit = (e) => {



    if (isCheck.length > 0) {
      setLoader(false);
      e.preventDefault();
      const data = {
        cat: isCheck,
      };
      setLoader(true);
      axios.post(`/api/select_category`, data).then((res) => {

        setLoader(false);

        if (res.data.status === 200) {
          setLoader(false);
          history.push({
            pathname: "/",
          });
        } else if (res.data.status === 401) {

          swal("Warning", res.data.message, "warning");
        } else {

          setCategory({
            ...selectCategory,
            error_list: res.data.validation_errors,
          });
        }
      }).catch((err) => {
        setLoader(false);

      });;
    }
  };

  const handleRoute = () => {
    history.push("/");
  };

  var viewCategory = "";

  if (loading) {
    //return <h5>Loading Category...</h5>
  } else {
    viewCategory = categoryList.map((item, index) => {
      return (
        <>
          <div
            key={index}
            className="col-md-2 text-center my-4"
            id="id_work_days"
          >
            <label className="parallelogram mt-2">
              <input
                key={item.id}
                id={item.id}
                name={item.name}
                type="checkbox"
                onChange={handleClick}
                checked={isCheck?.includes(item?.id)}
              />
              <span className="btn CatBtnS w-100">
                <div className="row justify-content-center">
                  <img
                    src={imageCdnUrl + item.image}
                    // src="https://unsplash.it/300/300"
                    alt=""
                    className="CatImgBlur"
                  />
                  {/* <div className="divUnder"></div> */}
                  <span className="pt-2 buttonBg pb-2">{item.name}</span>
                </div>
              </span>
            </label>
          </div>

          {/* <div className="col-md-3  text-center" id="id_work_days">
    <label className="">
      <input key={item.id} id={item.id} name={item.name} type="checkbox" onChange={handleClick}
        checked={isCheck.includes(item.id)} />
      <span className="btn btn-warning core-category-btn my-3 category-core py-auto">
        {item.name}

      </span>
    </label>
  </div> */}
        </>
      );
    });
  }

  return (
    <>
      <Navigation />

      <div className="main-container">
        <div className="container category-contaienr p-5 bg-dark  bg-img">
          <div className="d-flex justify-content-center align-items-center">
            <div className="center-frame">
              <img src={frame} alt="" className="frame" />
              <h6 className="category-title">CHOOSE CATEGORY</h6>
            </div>
          </div>

          {buffer ? (
            <>
              <div className="row">{viewCategory}</div>

              <div className="row justify-content-between mt-5">
                <div className="col-md-2">
                  <button onClick={handleRoute} className="btn BtnCats3">
                    <i className="fa-solid fa-arrow-left "></i> Back
                  </button>
                </div>

                {loader ? (
                  <div className="col-md-2">
                    <button
                      onClick={loginSubmit}
                      className="btn fw-bold w-100 BtnCats1"
                      disabled
                    >
                      <i className="fas fa-spinner fa-pulse"></i> &nbsp; Loading
                    </button>
                  </div>
                ) : (
                  <div className="col-md-2">
                    <button
                      onClick={loginSubmit}
                      className="btn fw-bold w-100 BtnCats1"
                    >
                      Done
                    </button>
                  </div>
                )}

                <div className="col-md-2">
                  <div className="BtnCats2">
                    <input
                      className="css-checkbox mx-2"
                      type="checkbox"
                      id="selectAll"
                      name="selectAll"
                      onChange={handleSelectAll}
                      checked={isCheckAll}
                    />
                    <label className="selectAll" htmlFor="selectAll">
                      <span className="ms-2">Select All</span>
                    </label>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <center className="mt-5">
                <div class="spinner-border text-warning" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </center>
            </>
          )}
        </div>
      </div>

      {/* <CategoryModal show={modalShow} setModalShow={setModalShow} onHide={() => setModalShow(false)} /> */}
    </>
  );
};

export default CoreCategory;
